import '../themeDefaults';

const DEFAULT_RANGE_SELECT_WIDTH = 200;
export const DATEPICKER_OVERLAP = 5;

export default ({ datepickerReact, transitions }) => ({
  alignRight: {
    '&$dateSelect': {
      left: 'auto',
      right: DEFAULT_RANGE_SELECT_WIDTH - DATEPICKER_OVERLAP,
      [`@media (max-width: ${datepickerReact.mobileBreakpoint}px)`]: {
        right: 0,
      },
    },
    '&$rangeSelect': {
      right: 0,
    },
  },
  dateSelect: {
    left: 160,
    position: 'relative',
    [`@media (max-width: ${datepickerReact.mobileBreakpoint}px)`]: {
      left: 0,
      right: 'auto',
      transition: 'none',
    },
    // 160 = width of date select - desired overlap
    right: 'auto',
    top: 0,
    transition: `all .3s ${transitions.easing.easeInOut}`,
  },
  onTop: {
    '&$rangeSelect': {
      bottom: 0,
    },
  },
  rangeSelect: {
    background: datepickerReact.rangePanelBackground,
    bottom: 'auto',
    position: 'absolute',
    right: 'auto',
    transition: `all .3s ${transitions.easing.easeInOut}`,
    width: DEFAULT_RANGE_SELECT_WIDTH,
    ...datepickerReact.rangeSelect,
  },
  root: {
    minWidth: DEFAULT_RANGE_SELECT_WIDTH,
    position: 'relative',
  },
});
